import axios from "../../fetch-api/fetch-api";

export function translateFilters(query, locale: string) {
  // pass custom locale in headers as BE relies on locale present in header
  return axios.post(`/${locale}/translate-filters`, query, { locale });
}
